import React, { Component } from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { QueryService } from 'services/queries';
import ErrorType from 'services/ErrorType';
import config from 'services/config';
import MoneyValue from 'components/MoneyValue';

import 'react-dates/lib/css/_datepicker.css';

let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};

class TransactionBox extends Component {

  constructor(props) {
    super(props)
    this.state = {
      extended: false
    }
    this.extendedToggle = this.extendedToggle.bind(this)
  }

  extendedToggle() {
    this.setState({extended: !this.state.extended})
  }

  render() {
    return (
      <div className="card">
        <h3 className="card-title">
          {_humanize(this.props.journal_display)}
          <div className="pull-right"><MoneyValue value={this.props.debits}/></div>
        </h3>
          <table className="table table-condensed">
            <thead>
              <tr>
                <th className="col-md-3 text-left">Transaction</th>
                <th className="col-md-3 text-left"
                    onClick={this.extendedToggle}
                    >
                  Balance type <i className={this.state.extended ? 'fa fa-minus-square-o' : 'fa fa-plus-square-o'}/>
                </th>
                <th className="col-md-3 text-right">Debits</th>
                <th className="col-md-3 text-right">Credits</th>
              </tr>
            </thead>
            <tbody>
              {this.props.transactions
                .filter( row => (this.state.extended ? row.level == 2 : row.level == 1) )
                .map(row => (
                <tr>
                  <td className="text-left">{row.transaction_type_display}</td>
                  <td className="text-left">{row.balance_type_display}</td>
                  <td className="text-right"><MoneyValue value={row.debits}/></td>
                  <td className="text-right"><MoneyValue value={row.credits}/></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    )
  }

}


class Transactions extends Component {

  constructor(props) {

    super(props);
    this.state = {
      transactionStartDate: this.props.maxDate,
      transactionEndDate: this.props.maxDate,
      focusedInput: null,
      transactions: []
    };

    this.onTransactionDatesChange = this.onTransactionDatesChange.bind(this);
    this.onTransactionDateFocusChange = this.onTransactionDateFocusChange.bind(this);
    this.isOutsideTransactionDateRange = this.isOutsideTransactionDateRange.bind(this);
    this.onPaginationChanged = this.onPaginationChanged.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.queryService = new QueryService(this.props.book)

  }

  async componentWillMount() {
    let newTransactions = await this._fetchTransactions(this.state.transactionStartDate, this.state.transactionEndDate)
    this.setState({...newTransactions})
  }

  onTransactionDateFocusChange(p) {
    this.setState({
      transactionDateFocus: p.focused
    });
  }

  async downloadCsv() {
    this.queryService.downloadSellerTransactions(this.state.transactionStartDate);
  }

  async onTransactionDatesChange({startDate, endDate}) {
    this.setState({
      transactionStartDate: startDate,
      transactionEndDate: endDate
    })
    if (startDate && endDate) {
      let newTransactions = await this._fetchTransactions(startDate, endDate);
      this.setState({...newTransactions});
    }
  }

  async _fetchTransactions(startDate, endDate) {
    try {
      let result = await this.queryService.getTransactionSummary(startDate, endDate)
      return {
        transactions: result,
        transactionStartDate: startDate,
        transactionEndDate: endDate
      }
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  isOutsideTransactionDateRange(date) {
    return moment().add(1, 'days').isBefore(date)
  }

  onPaginationChanged(pagination) {

  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-credit-card"></i> Transactions</h1>
            <p>Transactions by journal</p>
          </div>
          <div>
                <label className="transaction-date">
                  <span className="period">Period</span>
                  <DateRangePicker
                    startDate={this.state.transactionStartDate}
                    endDate={this.state.transactionEndDate}
                    onDatesChange={this.onTransactionDatesChange}
                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                    focusedInput={this.state.focusedInput}
                    numberOfMonths={3}
                    isOutsideRange={this.isOutsideTransactionDateRange}
                    minimumNights={0}
                  />
                </label>

            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
        <div className="row small">
          <div className="col-md-6">
              {this.state.transactions.filter( item => item.ledger_side == 'left' ).map(item => (
                <TransactionBox {...item} />
              ))}
          </div>
          <div className="col-md-6">
              {this.state.transactions.filter( item => item.ledger_side == 'right' ).map(item => (
                <TransactionBox {...item} />
              ))}
          </div>
        </div>
      </div>
    )
  }
}

export default Transactions;




// WEBPACK FOOTER //
// ./src/containers/Dashboard/Transactions/index.js